export default __webpack_public_path__ + "static/media/980.cf423054.gif";